import { FormControl } from "@angular/forms";
import { testCAEPF } from "@core/config/caepf-validador-config";

export function cpfCnpjCaepfValidator(control: FormControl) {
    var reCPF = new RegExp(/[0-9]{3}\.[0-9]{3}\.[0-9]{3}-[0-9]{2}/g);
    var reCNPJ = new RegExp(/[0-9]{2}\.?[0-9]{3}\.?[0-9]{3}\/?[0-9]{4}\-?[0-9]{2}/g);
    var reCAEPF = new RegExp(/[0-9]{3}\.?[0-9]{3}\.?[0-9]{3}\/?[0-9]{3}\-?[0-9]{2}/g);

    if (control.value != undefined && control.value != null && control.value != '') {

        let result = testCAEPF(control.value);
        let numbers = control.value.match(/\d/g);
        let numberLength = 0;
        if (numbers) {
            numberLength = numbers.join("").length;
        }
        if (numberLength > 11 && !reCNPJ.test(control.value) && !result)
            return {
                cnpjCaepf: true
            }
        else
            if (numberLength <= 11 && !reCPF.test(control.value))
                return {
                    cpf: true
                }
    }
    return null;
}

